import {RouteObject} from 'react-router-dom';

export const appAdminRoutes: RouteObject[] = [];
